<template>
  <!-- 商品类型选择 -->
  <!-- <el-form-item :prop="prop"> -->
  <el-cascader
    :options="options"
    :placeholder="inputPlaceholder"
    @change="changeProduct"
    :props="{ checkStrictly: true }"
    clearable
    v-model="result"
    ref="cascader"
  ></el-cascader>
  <!-- </el-form-item> -->
</template>

<script>
import { StageOptions } from "@/util/basicJson";
export default {
  data() {
    return {
      options: [],
      result: []
    };
  },
  props: {
    inputPlaceholder: {
      type: String,
      default: "请选择商品类型"
    },
    prop: {
      type: String,
      default: ""
    }
  },
  methods: {
    // 切换商品类型
    changeProduct(node) {
      let modelParentId = null;
      let modelId = null;
      this.result = [];
      console.log(node, "node");
      if (node.length == 1) {
        modelParentId = node[0];
        this.result = [modelParentId];
      } else if (node.length == 2) {
        modelParentId = node[0];
        modelId = node[1];
        this.result = [modelParentId, modelId];
      }
      console.log(this.result);
      this.$emit("changeP", this.result);
      // this.$emit("input", result);
    },
    initOptions() {
      let result = StageOptions.map(e => {
        let tempList = e.children.map(e2 => {
          return {
            label: e2.label,
            value: e2.value
          };
        });
        return {
          label: e.label,
          value: e.value,
          children: tempList
        }
      });
      this.options = result;
    },
    resetCascaderInput() {
      this.result = [];
    }
  },
  mounted() {
    this.initOptions();
  }
};
</script>

<style lang="scss" scoped></style>
